import {
  ProperAssignedVisit,
  ProperPreSaleVisit,
} from '../models/dashboardModels';

// Evento neutro para el calendario del dashboard (PreVenta, Renta, Secondary).
export interface VisitCalendarEvent {
  id: string;
  title: string;
  // ISO local: 2026-10-02T13:00:00
  start: string;
  color: string;
}

const STATUS_COLORS: { [key: string]: string } = {
  pending_approval: '#f59e0b',
  rescheduled: '#f59e0b',
  scheduled: '#0ea5e9',
  sheduled: '#0ea5e9', // typo histórico del backend de Renta/Secondary
  done: '#00b66b',
  cancelled: '#ef4444',
  deleted: '#ef4444',
  voided: '#ef4444',
};
const DEFAULT_COLOR = '#5b6f68';

// '02/10/2026' + '13:00' -> '2026-10-02T13:00:00' (null si no se puede leer).
const toIsoDateTime = (date?: string, time?: string): string | null => {
  const match = date?.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return null;
  const [, day, month, year] = match;
  const timeMatch = time?.match(/(\d{1,2}):(\d{2})/);
  const hh = timeMatch ? timeMatch[1].padStart(2, '0') : '00';
  const mm = timeMatch ? timeMatch[2] : '00';
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hh}:${mm}:00`;
};

const buildEvent = (
  id: string,
  name: string,
  date: string,
  time: string,
  status: string,
): VisitCalendarEvent[] => {
  const start = toIsoDateTime(date, time);
  if (!start) return [];
  return [
    {
      id,
      title: `${time} · ${name}`,
      start,
      color: STATUS_COLORS[status] ?? DEFAULT_COLOR,
    },
  ];
};

export const preSaleVisitsToCalendarEvents = (
  visits: ProperPreSaleVisit[],
): VisitCalendarEvent[] =>
  visits.flatMap((v) =>
    buildEvent(
      v.id,
      v.projectInfo.name,
      v.visitInfo.visit_date,
      v.visitInfo.visit_time,
      v.visitInfo.status,
    ),
  );

export const rentVisitsToCalendarEvents = (
  visits: ProperAssignedVisit[],
): VisitCalendarEvent[] =>
  visits.flatMap((v) =>
    buildEvent(
      v.id,
      v.propertyInfo.name,
      v.visitInfo.visit_date,
      v.visitInfo.visit_time,
      v.visitInfo.status,
    ),
  );
